import cookies from 'browser-cookies';
import { whenOlarkExists } from './utils/dom-utils';
import {submitHubspotLeadCaptureForm} from './hubspot';

const HUBSPOT_CHAT_LEAD_CAPURE_FORM_ID = 'a8feece4-7e53-485f-b37c-2616c9ac37ca';

// Prospective customers
const CHATBOX_TEXT_VALUES = {
  PROSPECT_ONLINE_MSG: "Looks like you're new here! We're happy to answer any general questions you have about Olark :) If you have an account with us, please <a href='https://www.olark.com/account/login'>log in</a>.",
  FREE_OFFLINE_MSG: "Need help? Search our <a href='https://www.olark.com/help'>Help Center</a> for immediate answers. Want to chat with us? <a href='https://www.olark.com/pricing'>Upgrade to a premium plan</a> for chat support!"
};


function setupApiCalls(olark) {
  captureCustomerInfo(olark);
  setupPaidOnlySupport(olark);
}

/**
 * Determine whether we have a new customer
 *
 * @return {Boolean}
 */
function isNewCustomer() {
  return cookies.get('ajs_user_id') === null;
}

/**
 *
 */

function setupPaidOnlySupport(olark) {
  var isPaid = cookies.get('olk_p');
  var customerValue = "Prospective Customer";

  if(isPaid === 'true') {
    // Paid customer state
    olark('api.box.show');
    customerValue = "Paid Customer";
  } else if(isPaid === 'false') {
    // Free customer state
    olark('api.box.hide');
    olark.configure('system.force_offline', true);
    olark.configure('system.offline_msg_mode', 0);
    olark.configure("locale.away_message", CHATBOX_TEXT_VALUES.FREE_OFFLINE_MSG);
    customerValue = "Free Customer";
  } else {
    // Prospect customer state
    olark('api.box.show');
    olark.configure("locale.welcome_message", CHATBOX_TEXT_VALUES.PROSPECT_ONLINE_MSG);
  }

  olark('api.chat.updateVisitorStatus', {
    snippet: customerValue
  });

  olark('api.chat.onBeginConversation', function() {
    olark('api.chat.sendNotificationToOperator', {
      body: customerValue
    });
  });
}

/**
 * Captures info on customers visiting the site.
 */
function captureCustomerInfo(olark) {
  const olarkSiteIdString = (cookies.get('os') || "").replace(/[^\d-]/,"");

  olark("api.visitor.updateCustomFields", {
    site_idstring: olarkSiteIdString
  });

  olark('api.chat.onCommandFromOperator', function(event) {
      if( event.command.name.toLowerCase().startsWith('sale') ) {
        olark('api.visitor.getDetails', function(visitor){
          analytics.track("Visitor Marked as Sales Chat", {
            site: "marketing",
            new_customer: isNewCustomer(),
            email: visitor.emailAddress,
            country: visitor.country
          });
        });
        olark('api.chat.sendNotificationToOperator', {
          body: 'marked sales'
        });
      }
  });


  olark('api.chat.onBeginConversation', function () {
    olark('api.visitor.getDetails', function(visitor){
      submitHubspotLeadCaptureForm(visitor.emailAddress, HUBSPOT_CHAT_LEAD_CAPURE_FORM_ID);
      analytics.identify({email: visitor.emailAddress});
      analytics.track("Visitor Chatted with Olark", {
        site: "marketing",
        new_customer: isNewCustomer(),
        email: visitor.emailAddress,
        country: visitor.country
      });
    });

    if (olarkSiteIdString) {
      olark('api.chat.sendNotificationToOperator', {
        body: 'https://olarkacle.olark.net/?q=' + olarkSiteIdString
      });
    }

  });

  olark('api.chat.onOfflineMessageToOperator', function() {
    analytics.track("Visitor Emailed Olark", { site: "marketing", 'new_customer':isNewCustomer() });
  });

  // Detect cookie values that need to be displayed to the operator.
  // These can be used by VWO tests to set values that the operator sees
  // upon chat start and in the details (e.g. to know which test variant
  // the user is seeing).
  //
  // Example:
  //
  //    var hoursToExist = 24;
  //    var date = new Date(); date.setTime(date.getTime() + (hoursToExist*60*60*1000));
  //    var encodedValue = btoa(JSON.stringify({someKey: "something you want to show the operator"}));
  //    document.cookie = "_olark_info_SOMETHING=" + encodedValue + "; expires=" + date.toGMTString();
  //
  // You can use this format in the VWO Javascript to set the values. Realize
  // that the visitors will be able to inspect our Javascript, so be careful
  // about what information you put in there.
  const allCookies = cookies.all();
  let customInfo = {};
  let customMessage = "";
  Object.keys(allCookies).forEach(function(cookieName) {
    if (/^_olark_info_.+/.test(cookieName)) {
      const encodedCookieValue = allCookies[cookieName];
      const infoObject = JSON.parse(global.atob(encodedCookieValue));
      Object.keys(infoObject).forEach(function(infoKey) {
        customInfo[infoKey] = infoObject[infoKey];
        customMessage += "\n - " + infoKey + ": " + infoObject[infoKey];
      });
    }
  });
  if (Object.keys(customInfo).length > 0) {
    olark("api.visitor.updateCustomFields", customInfo);
    olark("api.chat.onBeginConversation", function() {
      olark("api.chat.sendNotificationToOperator", {body: "Customer has custom info:" + customMessage});
    });
  }

}

export default function initOlarkApiCalls() {
  whenOlarkExists(setupApiCalls);
}
